var Iframe_default = {
  "iframe": "_94oK2"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
